import { render, staticRenderFns } from "./profitdetail.vue?vue&type=template&id=f953ed6a&scoped=true&"
import script from "./profitdetail.vue?vue&type=script&lang=js&"
export * from "./profitdetail.vue?vue&type=script&lang=js&"
import style0 from "./profitdetail.vue?vue&type=style&index=0&id=f953ed6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f953ed6a",
  null
  
)

export default component.exports